<div class="empty-button" [ngClass]="size"></div>
